<app-service-layout-v2
  [serviceParams]="serviceParams"
  [serviceFaqs]="serviceFaqs"
  [currentServiceIcon]="'https://cdn.ggboost.com/images/services/lol/' + service + '.webp'"
  [availableServices]="availableServices">
</app-service-layout-v2>
